export default "https://statics.cloudfastin.top/static/v1.27.38.3-s.dispute.2/store/images/aliexpress.png?e540bd3642a1880610748540550b3197";